import { render, staticRenderFns } from "./PLaylist-item.vue?vue&type=template&id=4d341121&scoped=true&"
import script from "./PLaylist-item.vue?vue&type=script&lang=js&"
export * from "./PLaylist-item.vue?vue&type=script&lang=js&"
import style0 from "./PLaylist-item.vue?vue&type=style&index=0&id=4d341121&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d341121",
  null
  
)

export default component.exports